import {useSendFeedbackMutation} from "@/api/feedbackApi";
import Modal from "@/components/Common/Modal";
import AutosizeTextarea from "@/components/Common/forms/AutosizeTextarea";
import {isFeedbackModalOpenAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {useState, type FC} from "react";
import {useTranslation} from "react-i18next";

const FeedbackModal: FC = () => {
  const {t} = useTranslation("feedback");
  const setIsOpen = useSetAtom(isFeedbackModalOpenAtom);
  const {mutate, isPending} = useSendFeedbackMutation();
  const [text, setText] = useState("");

  const onClose = () => setIsOpen(false);

  return (
    <Modal
      backgroundClassName="max-w-120 w-[90vw]"
      modalTitle={t("feedback_title")}
      onClose={onClose}
      onConfirm={() => mutate(text.trim(), {onSuccess: onClose})}
      confirmButtonText={t("feedback_submit")}
      isConfirmDisabled={!text.trim()}
      isLoading={isPending}
      shouldCloseOnConfirm={false}>
      <div className="flex flex-col gap-2">
        <p className="text-neutral-grey-dark text-sm">{t("feedback_subtitle")}</p>
        <AutosizeTextarea
          minRows={4}
          value={text}
          placeholder={t("feedback_placeholder")}
          onChange={e => setText(e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default FeedbackModal;
